import appConstants from '../../../../constants';
import useImage from '../../../../hooks/ui/useImage';
import CCPlaceholderImageMediumCustomSize from '../../../libs/CiscoCore/Placeholder/Image/Medium/CustomSize';
import computeClassName from "../../../../utils/computeClassName";
import {getValidProp} from "../../../../utils/cleanValidateStringPropValue";

const DISPLAY_CONTEXT_PARTNER_RESULT_GRID = 'partner result grid';
const DISPLAY_CONTEXT_PARTNER_PROFILE = 'partner profile';

export const constants = Object.freeze({
  COMPONENT_NAME: 'PartnerLogo',
  CLASSNAME_BASE: '',
  CLASSNAME_CONTEXT: Object.fromEntries(new Map([
    [DISPLAY_CONTEXT_PARTNER_RESULT_GRID, 'h-cc-17 xs:h-cc-18'],
    [DISPLAY_CONTEXT_PARTNER_PROFILE,'h-cc-17 3xs:h-20 2xs:h-24 xs:h-cc-30' ],
  ])),
  CLASSNAME_IS_LOADING: {
    true: 'animate-pulse',
    false: ''
  },
  DISPLAY_CONTEXT_PARTNER_RESULT_GRID: DISPLAY_CONTEXT_PARTNER_RESULT_GRID,
  DISPLAY_CONTEXT_PARTNER_PROFILE: DISPLAY_CONTEXT_PARTNER_PROFILE,
  DISPLAY_CONTEXT_DEFAULT: DISPLAY_CONTEXT_PARTNER_RESULT_GRID,
  DISPLAY_CONTEXTS: [DISPLAY_CONTEXT_PARTNER_RESULT_GRID, DISPLAY_CONTEXT_PARTNER_PROFILE]

});

const propsDefaults = Object.freeze( {
  partnerLogoAltText: 'Partner logo',
  partnerLogoPlaceholderAltText: 'Partner logo placeholder',
  displayContext: constants.DISPLAY_CONTEXT_DEFAULT
});

function getComputedClassName(propsClassName, displayContext, isLoading = false) {
  return computeClassName(propsClassName, `${constants.CLASSNAME_BASE} ${constants.CLASSNAME_CONTEXT[displayContext]} ${constants.CLASSNAME_IS_LOADING[isLoading]}`);
}

function getValidDisplayContext(displayContext) {
  return getValidProp(
    displayContext,
    'displayContext',
    constants.DISPLAY_CONTEXT_DEFAULT,
    constants.DISPLAY_CONTEXTS,
    constants.COMPONENT_NAME,
    appConstants.APP_DEBUG_LOGGER
  )
}

function computePartnerLogoUrl(partnerBeGeoId) {
  return `${appConstants.PARTNER_LOGO_CISCO_CDN_URL}${partnerBeGeoId}${appConstants.PARTNER_LOGO_FILE_EXTENSION}`;
}

function LogoPlaceholder({containerClassName, imgAltText}) {
  return (
    <div className={containerClassName}>
      <CCPlaceholderImageMediumCustomSize title={imgAltText} className="h-full object-contain"/>
    </div>
  )
}

export default function PartnerLogo({
  partnerBeGeoId,
  partnerLogoAltText = propsDefaults.partnerLogoAltText,
  partnerLogoPlaceholderAltText = propsDefaults.partnerLogoPlaceholderAltText,
  displayContext = propsDefaults.displayContext,
  className = ''
}) {
  const computedClassName = getComputedClassName(className, getValidDisplayContext(displayContext));
  const computedPartnerLogoUrl = computePartnerLogoUrl(partnerBeGeoId);
  const { hasLoaded, hasError } = useImage(computedPartnerLogoUrl);
  const computedLoadingClassName = getComputedClassName(className, getValidDisplayContext(displayContext), !hasError && !hasLoaded);

  if (hasError) {
    return (
      <LogoPlaceholder containerClassName={computedClassName} imgAltText={partnerLogoPlaceholderAltText}/>
    );
  }
  else {
    if (!hasLoaded) {
      return (
        <LogoPlaceholder containerClassName={computedLoadingClassName} imgAltText={partnerLogoPlaceholderAltText}/>
      );
    }
    return (
      <div className={computedClassName}>
        <img alt={partnerLogoAltText}
             title={partnerLogoAltText}
             src={computedPartnerLogoUrl}
             className="h-full object-contain"/>
      </div>
    );
  }
}
